'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.UIConstants = exports.UIEvents = undefined;

var _events = require('./events');

var UIEvents = _interopRequireWildcard(_events);

var _constants = require('./constants');

var UIConstants = _interopRequireWildcard(_constants);

var _UIFacade = require('./UIFacade');

var _UIFacade2 = _interopRequireDefault(_UIFacade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.UIEvents = UIEvents;
exports.UIConstants = UIConstants;

/**
 * @method
 *
 * @param {AppEventEmitter} outgoingDispatcher
 * @param {AppEventEmitter} internalEventDispatcher
 * @return {UIFacade}
 */
/**
 * This module exports the interface of the UI package
 * @module UI
 */

var create = exports.create = function create(outgoingDispatcher, internalEventDispatcher) {
  return new _UIFacade2.default(outgoingDispatcher, internalEventDispatcher);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/UI/index.js
// module id = 165
// module chunks = 0